import Block from "base/Block";

class LangSwitch extends Block {
	static get blockName() {
		return 'b-lang-switch';
	}

	onInit() {
		let newUrl = '';
		const currentUrl = window.location.pathname + window.location.search;

		if (this.el.getAttribute('href') == '/') {
			newUrl = currentUrl.replace('/en/', '/');
		}
		else {
			newUrl = '/en' + currentUrl;
		}

		if (newUrl) {
			fetch(location.protocol + '//' + location.host + newUrl)
				.then(response => {
					if (response.status == 200 || response.status == 301) {
						this.el.setAttribute('href', newUrl);
					}
				});
		}
	}
}

Block.register(LangSwitch);

export default LangSwitch;
